import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import styled from "styled-components";
import { Colors } from 'styles/constants'

interface PasswordStrengthProps {
  color: string;
  value: number;
  copy: string;
}

const StrengthBar = styled(LinearProgress) `{
  width: 100%;
  min-height: 7px;
}`;

const StrengthCopy = styled.p `{
  font-size: 12px;
  margin-top: -0.05rem;
  color: ${Colors.Slate};
}`;

const StrengthContainer = styled.div `{
  width: 100%;
  color: ${props => props.color};
}`;

const PasswordStrength = ({color, value, copy}: PasswordStrengthProps) => {

  return (
    <StrengthContainer color={color}>
      <StrengthBar variant="determinate" color="inherit" value={value}/>
      <StrengthCopy>{copy}</StrengthCopy>
    </StrengthContainer>
  )
};

export default PasswordStrength;
